// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IHDJ","select":"styles_select__i9C6x"};